import { render } from "./edit_power.vue?vue&type=template&id=79bdd2d1&scoped=true"
import script from "./edit_power.vue?vue&type=script&lang=js"
export * from "./edit_power.vue?vue&type=script&lang=js"

import "./edit_power.vue?vue&type=style&index=0&id=79bdd2d1&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bdd2d1"]])

export default __exports__